import { useStaticQuery, graphql } from "gatsby"

const useOurJourney = () => {
  const query = useStaticQuery(graphql`
    query MyQuery {
      OurJourneyPosts: allGhostPost(
        filter: {tags: {elemMatch: {slug: {in: ["our-journey", "hash-ourjourney"]}}}}
        sort: {order: DESC, fields: [published_at]}
        limit: 1000
        skip: 0
      ) {
        edges {
          node {
            id
            title
            slug
            feature_image
            excerpt
            published_at(formatString: "MMMM YYYY")
            primary_author {
              name
              slug
              profile_image
            }
            tags {
              name
              slug
            }
          }
        }
      }
    }
  `);

  return query;
}

export default useOurJourney;
